import * as Lambda from './LambdaApi';

interface QuotaInterface {
    totalQuota: number;
    residentCount: number;
    receipts: ReceiptInterface[];
}

interface ReceiptInterface {
    orderId: string;
    isValid: boolean;
    isCanceled: boolean;
    isExpired: boolean;
    provider: string;
    quota: number;
    expiresAt: number;
}

interface IntentSecretInterface {
    clientSecret: string;
}

export const getMyQuota = async (paymentManagerId = ''): Promise<QuotaInterface> => {
    try {
        console.log(paymentManagerId, 'pp');
        const apiPath = paymentManagerId ? `/payment-managers/${paymentManagerId}/quotas` : `/me/quotas`;

        const lambda = paymentManagerId ? 'public' : 'lambda';
        const quota = await Lambda.Get(apiPath, {}, lambda);

        return quota.quotas;
    } catch (err) {
        console.log('Err:', err);

        throw Error(err);
    }
};

export const getMyPaymentManager = async () => {
    const apiPath = '/me/paying-manager-token';
    try {
        const response = await Lambda.Get(apiPath, {}, 'lambda');

        return response;
    } catch (err) {
        return false;
    }
};

export const getPaymentIntentSecret = async (paymentManagerId, name): Promise<IntentSecretInterface> => {
    console.log(paymentManagerId, 'pp')
    const apiPath = paymentManagerId
        ? `/payment-managers/${paymentManagerId}/payment-intent/secret`
        : '/me/payment-intent/secret';

    const lambda = paymentManagerId ? 'public' : 'lambda';

    const params = name ? { name } : {};
    const response = await Lambda.Get(apiPath, params, lambda);

    return response;
};

export const getPaymentMethod = async (paymentMethodId, paymentManagerId) => {
    const apiPath = paymentManagerId
        ? `/payment-managers/${paymentManagerId}/payment-method/${paymentMethodId}`
        : `/me/payment-method/${paymentMethodId}`;

    const lambda = paymentManagerId ? 'public' : 'lambda';

    const response = await Lambda.Get(apiPath, {}, lambda);

    return response;
};

export const startSubscription = async (paymentMethodId, numberOfUsers, couponCode, paymentManagerId, invitationId) => {
    const apiPath = paymentManagerId
        ? `/payment-managers/${paymentManagerId}/payment-method/${paymentMethodId}`
        : `/me/payment-method/${paymentMethodId}`;

    const lambda = paymentManagerId ? 'public' : 'lambda';

    const response = await Lambda.Post(
        apiPath,
        {
            numberOfUsers,
            couponCode,
            invitationId,
        },
        lambda,
    );

    return response;
};

export const getUpcomingSubscription = async (paymentManagerId, numberOfUsers, couponCode) => {
    const apiPath = `/payment-managers/${paymentManagerId}/upcoming-invoices`;

    const response = await Lambda.Post(
        apiPath,
        {
            numberOfUsers,
            couponCode,
        },
        'lambda',
    );

    return response;
};

export const listPaymentMethods = async (paymentManagerId) => {
    const apiPath = `/payment-managers/${paymentManagerId}/payment-methods`;

    const lambda = paymentManagerId ? 'public' : 'lambda';

    const response = await Lambda.Get(apiPath, {}, lambda);

    return response;
};

export const detachPaymentMethod = async (paymentManagerId, paymentMethodId) => {
    const apiPath = `/payment-managers/${paymentManagerId}/payment-method/${paymentMethodId}`;

    const lambda = paymentManagerId ? 'public' : 'lambda';

    const response = await Lambda.Delete(apiPath, {}, lambda);

    return response;
};

export const getPromoCodeObject = async (couponCode) => {
    const apiPath = `/payment-managers/promocodes/${couponCode}`;
    try {
        const response = await Lambda.Get(apiPath, {}, 'lambda');

        return response;
    } catch (err) {
        return err.message === 'Error: Request failed with status code 404'
            ? { success: false, message: 'The Coupon code is invalid. Please check the code you have entered.' }
            : false;
    }
};
